<template>
  <div class="main">
    <MainHeader v-if="globalData" :data="globalData" />
    <FooterBtn v-if="$route.name!='unit'" />
    <router-view />
    <MainFooter />
    <transition name="show-donate">
    <donate v-if="showDonate" @close="showDonate=false"/>
    </transition>
  </div>
</template>

<script>
import MainHeader from "../components/header/MainHeader.vue";
import MainFooter from "../components/footer/MainFooter.vue";
import FooterBtn from "../components/main/FooterBtn.vue";
import donate from '@/components/modal.vue'

export default {
  data() {
    return {
      showDonate:false
    };
  },
  computed: {
    globalData() {
      return this.$store.getters.getGlobalData;
    }
  },
  mounted() {
    setTimeout(() => this.showDonate = true , 5000)
    if (this.globalData == null) {
      this.$axios.defaults.headers.common["Accept-Language"] = this.$cookie.get(
        "language"
      )
        ? this.$cookie.get("language")
        : "fa";
      this.$axios.get("front/global").then((res) => {
        let bigData = {
          settings: {},
          keys: {},
          menus: {
            header: [],
            footer: []
          }
        };
        bigData.languages = res.data.home.languages;
        res.data.home.settings.forEach((item) => {
          bigData.settings[item.name] = item.value;
        });
        res.data.home.keys.forEach((item) => {
          bigData.keys[item.key] = item.value;
        });
        res.data.home.menus.forEach((item) => {
          if (item.group_id == 1) {
            bigData.menus.header.push(item);
          } else {
            bigData.menus.footer.push(item);
          }
        });
        console.log(bigData)
        this.$store.commit("setGlobalData", bigData);
      });
    }
  },
  watch:{
    "$route"(newVal){
      this.$nextTick(() => {
        setTimeout(() => this.showDonate = true , 5000)
      })
    }
  },
  components: { MainFooter, MainHeader, FooterBtn , donate }
};
</script>
<style>
.main {
  overflow: hidden;
}

/*start donate modal*/
.show-donate-enter-active,
.show-donate-leave-active {
  transition: opacity 0.5s ease;
}

.show-donate-enter-from,
.show-donate-leave-to {
  opacity: 0;
}
@keyframes show-donate {
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
/*end donate modal*/
</style>
